const ethers = require("ethers");
const abi = require("./abi.json");

const { contractAddress_list } = require("../contracts.jsx");
const { nils } = require("../../utils/utils");

const getgasinfo = async () => ({});

class FBikeSkin_Contract {
  constructor({ contractAddress, provider, signer, nosigner = false }) {
    this.provider = provider;
    this.signer = signer;
    this.abi = abi;
    this.contractAddress = contractAddress;
    if (nosigner === true)
      this.contract = new ethers.Contract(
        this.contractAddress,
        this.abi,
        provider,
      );
    else
      this.contract = new ethers.Contract(
        this.contractAddress,
        this.abi,
        signer,
      );
  }

  async mintToken(recipient, _name, _rarity) {
    const gasinfo = await getgasinfo();
    let tx = await this.contract.mintToken(recipient, _name, _rarity, gasinfo);
    tx = await tx.wait();
    return tx;
  }

  async mintToken_w_box(lootboxTxHash, recipient, _name, _rarity) {
    const gasinfo = await getgasinfo();
    let tx = await this.contract.mintToken_w_box(
      lootboxTxHash,
      recipient,
      _name,
      _rarity,
      gasinfo,
    );
    tx = await tx.wait();
    return tx;
  }

  async applySkin(skinid, hid) {
    const gasinfo = await getgasinfo();
    let tx = await this.contract.applySkin(skinid, hid, gasinfo);
    tx = await tx.wait();
    return tx;
  }

  async releaseSkin(skinid) {
    const gasinfo = await getgasinfo();
    let tx = await this.contract.releaseSkin(skinid, gasinfo);
    tx = await tx.wait();
    return tx;
  }

  async getTokenInfo(tokenId) {
    try {
      const [skin, owner] = await this.contract.getTokenInfo(tokenId);
      const skinObject = {
        skinid: parseInt(skin[0]),
        name: skin[1],
        rarity: skin[2],
        appliedTo: parseInt(skin[3]),
        vault: owner,
      };

      return skinObject;
    } catch (err) {
      console.log(
        `Error fetching token info for token ID ${tokenId}:`,
        err.message,
      );
      return null;
    }
  }

  async getTokenOwner(tokenId) {
    return await this.contract.getTokenOwner(tokenId);
  }

  async getTokenIdsOfAccount(addr) {
    let tokenIds = await this.contract.getTokenIdsOfAccount(addr);
    return tokenIds.map((id) => parseInt(id));
  }

  async burn(tokenId) {
    const gasinfo = await getgasinfo();
    let tx = this.contract.burn(tokenId, gasinfo);
    return tx;
  }

  async burnTokens(tokenIds) {
    const gasinfo = await getgasinfo();
    let tx = this.contract.burnTokens(tokenIds, gasinfo);
    return tx;
  }
}

const name = "fbikeskin";
const get_contract_address = () => {
  return contractAddress_list[name];
};

const get_FBikeSkin_Contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const provider = !nils(ext.rpc)
    ? new ethers.JsonRpcProvider(ext.rpc)
    : new ethers.BrowserProvider(window.ethereum);
  const signer = ext.nosigner === true ? null : await provider.getSigner();
  const pars = { contractAddress, provider, signer, ...ext };
  const runner = new FBikeSkin_Contract(pars);
  return runner;
};

const FBikeSkin = {
  class: FBikeSkin_Contract,
  get_contract: get_FBikeSkin_Contract,
};

module.exports = FBikeSkin;
